import { fetchGet } from './fetch'

export const getInstallationComponents = async installationId => {
  const url = `/api/installation/${encodeURIComponent(installationId)}/components`
  return await fetchGet(url)
}
